import { defineStore } from "pinia";
import { GameModalState } from "@/stores/common/game/gameModal";
import { GameModalService } from "@core/services/common/game/gameModalService";

export const useGameModal = defineStore("gameModal", {
  state: (): GameModalState => ({
    isActive: false,
    winnersPoints: 0,
    score: 0,
    chance: 3,
    bonus: 0,
    data: {
      rank: null,
      points: null
    }
  }),

  getters: {
    isActiveNewYearsGame: (state) => !state.winnersPoints
  },

  actions: {
    async SAVE_GAME_PROGRESS (points: number, context: Record<string, any>) {
      await GameModalService.saveGameProgress(points, context);
    },

    async GET_CURRENT_GAME_PROGRESS () {
      this.data = await GameModalService.getCurrentGameProgress();
    }
  }
});